import {createMuiTheme } from '@material-ui/core/styles';

import { primaryColor } from './config/theme';

export const theme = createMuiTheme({
	palette:{
		primary: {
			light: '#ff9933',
			main: primaryColor,
			dark: primaryColor,
		},
		secondary: {
			light: '#ff9933',
			main: primaryColor,
			dark: primaryColor,
		},
	},
	typography: {
		useNextVariants: true
	},
});

const style = {};

export default style;
